import type { FormikProps } from 'formik'
import { Button } from 'sutra/components/Button'
import { Form, FormItem } from 'sutra/components/Form'
import { Select } from 'sutra/components/Select/Select'

import { FormikFormItem } from 'components'

const layout = {
  labelCol: { span: 5 },
  wrapperCol: { span: 19 },
}

interface ShareFormValues {
  role: string
  shared_email: string
  first_name: string
  last_name: string
  org: string
  team: string
}

interface ShareFormViewProps {
  formik: FormikProps<ShareFormValues>
  isUserAdmin: boolean
}

export const ShareFormView = ({
  formik,
  isUserAdmin,
}: ShareFormViewProps): JSX.Element => (
  <Form
    layout="horizontal"
    className="share-form"
    onFinish={() => formik.handleSubmit()}
    {...layout}
  >
    <FormikFormItem
      label="Email"
      field="shared_email"
      formik={formik as unknown as FormikProps<Record<string, unknown>>}
    />
    {isUserAdmin && (
      <FormItem label="Role">
        <Select
          defaultValue={formik.values.role}
          style={{ width: '100%' }}
          onChange={(v) => formik.setFieldValue('role', v)}
          options={[
            { value: 'viewer', label: 'Viewer' },
            ...(isUserAdmin ? [{ value: 'admin', label: 'Admin' }] : []),
          ]}
        />
      </FormItem>
    )}

    <FormikFormItem
      label="First name"
      field="first_name"
      formik={formik as unknown as FormikProps<Record<string, unknown>>}
    />
    <FormikFormItem
      label="Last name"
      field="last_name"
      formik={formik as unknown as FormikProps<Record<string, unknown>>}
    />
    <FormikFormItem
      label="Organization"
      field="org"
      formik={formik as unknown as FormikProps<Record<string, unknown>>}
    />
    <FormikFormItem
      label="Team"
      field="team"
      formik={formik as unknown as FormikProps<Record<string, unknown>>}
    />

    <Button
      style={{ margin: '0 auto', display: 'block' }}
      variant="primary"
      type="submit"
      loading={formik.isSubmitting}
    >
      Create User & Share Yogi Hub
    </Button>
  </Form>
)
